/**
 * @fileoverview Agent definition for weave-snapshotter-short-v1.
 *
 * Short-form variant of the weave snapshotter. Focuses on plot thread
 * lifecycle and character arc touch detection without storyline concepts.
 * Uses writtenPlot as the structural reference framework.
 *
 * @category narrative.continuity.analysis
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'weave-snapshotter-short-v1',
  kind: 'primitive',
  name: 'Weave Snapshotter (Short-Form)',
  description: 'Synthesizes continuity data for short-form projects by analyzing a chapter against character arcs (simplified progress). No storyline concepts, no beat-level arc tracking. Plot threads provided as read-only context.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'narrative.continuity.analysis',
    usedBy: [
      'use-weave-snapshotter-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'weave-snapshotter-v2',
      'plot-snapshotter-v2',
      'character-snapshotter-single-v2',
    ],
  },
};
